export function domReady(fn) {
    function onReady() {
        document.removeEventListener('DOMContentLoaded', onReady);
        fn();
    }
    if (document.readyState === 'loading') {
        document.addEventListener && document.addEventListener('DOMContentLoaded', onReady);
    }
    else {
        fn();
    }
}
